module.exports = __webpack_public_path__ + "img/QRtest.0c070e41.png";